import { trpc } from '@/lib/trpc';
const useLogout = () => {
	const utils = trpc.useUtils();

	const { mutate } = trpc.user.logout.useMutation({
		onMutate: async () => {
			await utils.user.get.cancel();
		},
		onSettled: async () => {
			await utils.invalidate();
		},
	});

	return { logout: mutate };
};

export default useLogout;
